module.exports = __webpack_public_path__ + "img/1.e07d287d.png";